import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ReactLoading from 'react-loading';

import { FaTelegramPlane, FaPlus, FaMinus, FaRegDizzy, FaTimes } from "react-icons/fa";
import { BsChevronUp } from 'react-icons/bs';
import { AiFillUpCircle, AiOutlineUp } from 'react-icons/ai';
import { FaChartSimple, FaMoneyCheckDollar, FaInfinity } from "react-icons/fa6";

import FAQ from '../../component/fap/fap';
import Layout from "../../component/layout/layout";
import "./home.scss";
import { InitLoading, ToHTML, scrollTo } from '../../util';
import firstSectionBackground from "../../assets/logo.svg"
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards } from 'swiper/modules';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const Home = () => {

	return (
		<>
			<Layout>
				< section className="first-section h-screen" id="first-section" >
					<div className="container overflow-hidden">
						<div className="flex flex-col text-center sm:text-left">
							<div className="row items-center justify-center">
								<div className=" pt-36"></div>
								<div className="col-12 col-sm-12 col-md-12 col-lg-7 mb-9 items-center justify-center">
									<div className="sm:pt-16">
										<div className="flex justify-start items-center gap-2">
											<img width={20} height={20} src="/assets/images/landing/lock.png" alt="" className="cursor-pointer hover:scale-110 mb-2" />
											<h6 className="">CREATE, TRADE AND LAUNCH</h6>
										</div>

										<h1 className="font-bold">
											<div className="">
												Land for creators,
												<br />
												mine for investors
											</div>
										</h1>
									</div>
									<div className="">
										<h6 className="">A <span className="primary-color">cross-chain NFT</span> launchpad and platform focusing on digital projects.</h6>
										<h6 className="">We're enabling <span className="primary-color">NFT</span> projects to connect with investors like never before.</h6>
										<br />
										<div className="flex items-center justify-start gap-2 mt-8">
											<button className="btn black-bg gap-2 text-white cursor-pointer hover:scale-105 font-bold" style={{ borderRadius: '2px', padding: '18px 29px' }}>
												<span>
													Connect to Wallet
												</span>
											</button>
											<a className=" underline gap-2text-black cursor-pointer hover:scale-105 font-bold" style={{ borderRadius: '2px', padding: '18px 10px' }}>
												<span>
													Browse all projects
												</span>
											</a>
										</div>
										<div className="flex flex-wrap items-center justify-start mt-4 gap-10">
											<div className="flex gap-3 justify-start items-start">
												<div className="mt-2">
													<div className=" bg-gray-100 p-2 rounded-full">
														<FaChartSimple />
													</div>
												</div>
												<div className="flex flex-col justify-center items-start">
													<div className="">Price</div>
													<div className="mt-2">
														<h4>$ 0.01</h4>
													</div>
												</div>
											</div>

											<div className="flex gap-3 justify-start items-start">
												<div className="mt-2">
													<div className=" bg-gray-100 p-2 rounded-full">
														<FaMoneyCheckDollar />
													</div>
												</div>
												<div className="flex flex-col justify-center items-start">
													<div className="">Market Cap</div>
													<div className="mt-2">
														<h4>$ 606.21k</h4>
													</div>
												</div>
											</div>
											<div className="flex gap-3 justify-start items-start">
												<div className="mt-2">
													<div className=" bg-gray-100 p-2 rounded-full">
														<FaInfinity />

													</div>
												</div>
												<div className="flex flex-col justify-center items-start">
													<div className="">Circulating Supply</div>
													<div className="mt-2">
														<h4>86.95 M</h4>
													</div>
												</div>
											</div>


										</div>

									</div>
								</div>
								<div className="col-12 col-sm-12 col-md-12 col-lg-5 mb-9">
									<Swiper
										effect={'cards'}
										grabCursor={true}
										className="cardSwiper"
										autoplay={{
											delay: 2500,
											disableOnInteraction: false,
										}}
										modules={[Autoplay, Pagination, Navigation, EffectCards]}
									>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/1.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/2.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/3.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/4.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/5.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/6.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/7.png" alt="" /></SwiperSlide>
										<SwiperSlide><img className="home-img" src="/assets/images/nft/8.png" alt="" /></SwiperSlide>
									</Swiper>

								</div>
							</div>
						</div>
					</div>
					<section className="simple-section pt-4 ">
						<div className="container mx-auto flex flex-col pt-8 pb-6 sm:pt-12 sm:pb-5">
							<div className="row">
								<div className="col-6 col-md-3 mb-8 text-center">
									<div className="">
										<p className="">Total Volume</p>
										<h4 className="primary-color">
											$1M+
										</h4>
									</div>
								</div>
								<div className="col-6 col-md-3 mb-8 text-center">
									<div className="">
										<p className="">Wallet Connected</p>
										<h4 className="primary-color">
											10K+
										</h4>
									</div>
								</div>
								<div className="col-6 col-md-3 mb-8 text-center">
									<div className="">
										<p className="">Total Transactions</p>
										<h4 className="primary-color">
											100k+
										</h4>
									</div>
								</div>
								<div className="col-6 col-md-3 text-center">
									<div className="">
										<p className="">Supported Chains</p>
										<h4 className="primary-color">
											EVM
										</h4>
									</div>
								</div>
							</div>
						</div>
					</section>
				</section >
			</Layout>
		</>
	);
};
export default Home;
